import { useEffect, useState } from "react";
import api from "../utils/api/axiosInstance";

export default function useProductReviewDigest({ productId, wizardData, reviewCount }) {
  const [digest, setDigest] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!productId || reviewCount < 3) {
      setDigest(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    const matchProfile = wizardData
      ? {
          primaryUseCase: wizardData.useCase,
          mustHaves: wizardData.mustHaves,
          budget: wizardData.budget,
        }
      : null;

    api
      .post("/ai/grok/review-digest", { productId, matchProfile })
      .then((res) => {
        if (cancelled) return;
        const data = res.data?.digest;
        if (data && !data.skipped) {
          setDigest(data);
        } else {
          setDigest(null);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.response?.data?.error || "Failed to load review digest");
          setDigest(null);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [productId, reviewCount, wizardData]);

  return { digest, loading, error };
}
